export default __webpack_public_path__ + "static/media/menu-leaderboard.2b64a214.png";